// eslint-disable-next-line @typescript-eslint/no-var-requires
const lightColors = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./blue_colors.scss`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const blackColors = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./black_colors.scss`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const variables = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./variables.scss`);

//           index:   0  1  2   3   4   5   6   7    8    9   10
export const space = [0, 4, 8, 16, 24, 32, 64, 96, 128, 256, 512];

let temporaryStylesHandle = null; // only for inheritance

export default {
  colors: {
    //...lightColors, //default
    modes: {
      Light: lightColors,
      Dark: blackColors,
    },
  },
  fonts: {
    body: 'GalanoGrotesque-Light, system-ui, sans-serif',
    heading: 'inherit',
    monospace: 'Menlo, monospace',
  },
  //           0   1   2   3   4   5   6   7   8
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    medium: 500,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  space,
  sizes: {
    avatar: 48,
  },
  shadows: {
    card: '0 0 4px rgba(0, 0, 0, .125)',
    card2: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
    level1: `0 16px 10px 0px var(--theme-ui-colors-pageMenuShadow1)`,
    level2: `0 11px 18px 0px var(--theme-ui-colors-pageMenuShadow2)`,
    level3: `0 13px 5px -1px var(--theme-ui-colors-pageMenuShadow3)`,
  },
  // rebass variants
  text: {
    widget: {
      error: {
        fontSize: 5,
        color: 'noTaskSelected',
      },
    },
    smallHeader: {
      fontWeight: 'medium',
      paddingBottom: 2,
      color: 'label',
      fontSize: 1,
    },
    text: {
      fontSize: 0,
      color: 'text',
    },
    link: {
      display: 'inline',
      fontSize: 0,
      color: 'primary',
      ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    overflow: {
      fontSize: 1,
      color: 'text',
      flex: 1,
      mx: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    badge: {
      fontSize: 1,
      backgroundColor: 'backgroundLighter',
      color: 'textLighter',
      padding: 1,
      maxWidth: '100px',
      borderRadius: variables.radius,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    heading: {
      fontSize: 3,
      color: 'text',
      whiteSpace: 'nowrap',
      minWidth: 'auto',
      marginRight: 3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flex: 1,
    },
    display: {
      color: 'heading',
      fontWeight: 'bold',
      fontSize: 4,
      whiteSpace: 'nowrap',
      minWidth: 'auto',
      marginRight: 2,
    },
    pageHeading: {
      variant: 'text.display',
      color: 'heading',
      fontWeight: 'bold',
      fontSize: 4,
      whiteSpace: 'nowrap',
      minWidth: 'auto',
      verticalAlign: 'middle',
      paddingLeft: 1,
      marginRight: 0,
    },
    pageTitle: {
      variant: 'text.pageHeading',
      fontWeight: 'normal',
    },
    caps: {
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    dialog: {
      title: {
        color: 'caretColor',
        fontWeight: 'normal',
        fontSize: 3,
        mr: 'auto',
      },
    },
  },
  variants: {
    filters: {
      sidebar: {
        section: {
          mb: 3,
          p: 1,
          color: '#8D99A6',
          title: {
            fontWeight: 'medium',
            fontSize: 0,
            mb: 2,
          },
          popup: {
            text: {
              color: 'buttonText',
              display: 'flex',
              alignItems: 'center',
              pb: 2,
              cursor: 'pointer',
              svg: {
                marginLeft: 'auto',
              },
            },
          },
          save: {
            savedRow: {
              mt: 2,
              display: 'flex',
              alignItems: 'center',
              color: 'buttonText',
              '> div': {
                cursor: 'pointer',
                marginRight: 'auto',
              },
              svg: {
                cursor: 'pointer',
                color: '#8D99A6',
                ':hover': {
                  color: 'buttonText',
                },
              },
            },
          },
        },
      },
      appliedFilters: {
        px: 3,
        py: 2,
        border: '1px solid',
        borderColor: 'regularBorder',
        alignItems: 'center',
      },
      unappliedFilters: {
        marginTop: '-1px',
        px: 3,
        py: 2,
        border: '1px solid',
        borderColor: 'regularBorder',
        row: {
          mb: 2,
          '> input': { flex: 1, mr: 2 },
          '> div': { flex: 1, mr: 2 },
        },
      },
      filterAmountCircle: {
        borderRadius: variables.radiusCircle,
        background: '#fff',
        width: 16,
        height: 16,
        fontSize: 0,
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary',
        textAlign: 'center',
        marginLeft: 1,
      },
    },
    historyList: {
      display: 'block',
      listStyle: 'none',
      margin: '0',
      padding: '0',
      position: 'relative',
      '::before': {
        content: '""',
        borderLeft: '2px solid #f2f2f2', // Isn't used elsewhere
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '12px', // icon.width / 2
      },
      wrapper: {
        borderRadius: variables.radius,
        marginBottom: 5,
        display: 'block',
        position: 'relative',
        ':last-child': {
          marginBottom: 0,
        },
      },
      icon: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff',
        width: '24px',
        height: '24px',
        border: '1px solid #e5e5e5', // Isn't used elsewhere
        borderRadius: '16px',
        float: 'left',
        inner: {
          fontSize: 0,
          color: '#c4c4c4', // Isn't used elsewhere
          display: 'block',
          margin: '0 auto',
        },
      },
      content: {
        paddingTop: '6px', // Don't center the icon next to the content
        paddingLeft: '24px', // icon width
        marginLeft: 4,
        header: {
          display: 'flex',
          marginBottom: 2,
          darker: {
            marginRight: 1,
            fontSize: 1,
            color: 'text',
          },
          lighter: {
            fontSize: 1,
            color: 'textLighter',
          },
        },
        body: {
          display: 'flex',
          color: 'textLighter',
          prev: {
            display: 'inline',
            px: 1,
            fontSize: 1,
            color: 'text',
            textDecoration: 'line-through',
            backgroundColor: 'redBackground',
          },
          curr: {
            display: 'inline',
            px: 1,
            fontSize: 1,
            color: 'text',
            backgroundColor: 'greenBackground',
          },
        },
      },
    },
    circularProgress: {
      color: `var(--theme-ui-colors-primary) !important`,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-12px',
      height: '24px !important',
      width: '24px !important',
    },
    circularProgressNotAbsolute: {
      color: `var(--theme-ui-colors-primary) !important`,
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-12px',
      height: '24px !important',
      width: '24px !important',
    },
    dialog: {
      container: {
        background: 'var(--theme-ui-colors-background)',
        fontFamily: 'body',
        flex: 1,
        overflowY: 'auto',
        flexDirection: 'column',
      },
      title: {
        py: 3,
        px: 4,
        display: 'flex',
        alignItems: 'center',
      },
      content: {
        py: 3,
        px: 4,
        flex: '1 1 auto',
        overflowY: 'auto',
      },
      actions: {
        flex: '0 0 auto',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 4,
        paddingBottom: 3,
      },
      action: {
        variant: 'variants.virtualTable.rowAction',
        ml: 2,
        p: 1,
        cursor: 'pointer',
      },
    },
    tasks: {
      list: {
        container: {
          borderRadius: 0,
          borderRight: '1px solid',
          borderColor: 'border',
          height: '100%',
          flex: 1,
          overflow: 'auto',
        },
        listElement: {
          common: temporaryStylesHandle = {
            px: 1,
            py: 2,
            alignItems: 'center',
            bg: '#fff',
            boxShadow: 'inset 0 -1px 0 0 rgba(100, 121, 143, 0.12)',
            cursor: 'pointer',
            ':hover': {
              // boxShadow: `inset 1px 0 0 ${colors.boxShadow}, inset -1px 0 0 ${colors.boxShadow}, 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15)`,
              zIndex: 1,
              position: 'relative',
              backgroundColor: 'hoveredBackground',
            },
          },
          selected: {
            ...temporaryStylesHandle,
            backgroundColor: 'selectedBackground',
          },
          unselected: {
            ...temporaryStylesHandle,
            backgroundColor: 'background',
          },
          rightSide: {
            justifyContent: 'center',
            alignItems: 'center',
            mx: 1,
            whiteSpace: 'nowrap',
          },
        },
      },
      detail: {
        container: {
          // nothing here ...
        },
      },
    },
    formikWrapper: {
      color: 'red',
    },
    items: {
      list: {
        listElement: {
          variant: 'variants.tasks.list.listElement.unselected',
        },
      },
    },

    virtualTable: {
      row: {
        px: 2,
        transition: '.1s all',
        alignItems: 'center',
        ':hover': { backgroundColor: 'hoveredBackground' },
      },
      rowActions: {
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'var(--theme-ui-colors-darkGray)',
      },
      columnHeader: {
        alignItems: 'center',
        flex: 1,
        px: 2,
        fontSize: 1,
        fontWeight: 'medium',
        color: 'buttonText',
      },
      columnCell: {
        alignItems: 'center',
        whiteSpace: 'nowrap',
        fontSize: 1,
        color: 'caretColor',
        flexWrap: 'wrap',
        '> div': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
      rowAction: {
        color: 'var(--theme-ui-colors-textLighter)',
        transition: '.15s transform',
        opacity: 0.55,
        minWidth: 'auto',
        ':focus, :hover': {
          opacity: 'initial',
          color: 'primary',
        },
      },
    },
    pageContainer: {
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    inputContainer: {
      common: temporaryStylesHandle = {
        p: 0,
        border: '1px solid',
        borderRadius: variables.radius,
        ' input': {
          p: 2,
          fontSize: 0,
          color: 'text',
          caretColor: 'var(--theme-ui-colors-caretColor)',
          '::placeholder': {
            color: 'placeholder',
          },
        },
      },
      default: {
        ...temporaryStylesHandle,
        borderColor: 'placeholder',
      },
      focused: {
        ...temporaryStylesHandle,
        borderColor: 'primary',
      },
    },

    /* --- PAGER ----------------------------------------------------------------------- */
    pager: {
      terminalPage: {
        px: 4,
        py: 2,
        cursor: 'pointer',
      },
      internalPage: {
        common: temporaryStylesHandle = {
          mx: 1,
          px: 3,
          py: 2,
          border: `1px solid`,
          borderRadius: variables.radiusHalf,
          cursor: 'pointer',
        },
        default: {
          ...temporaryStylesHandle,
          borderColor: 'placeholder',
          backgroundColor: 'transparent',
          color: 'black',
        },
        selected: {
          ...temporaryStylesHandle,
          borderColor: 'primary',
          backgroundColor: 'primary',
          color: 'white',
        },
      },
    },
    /* --- END -> PAGER ---------------------------------------------------------------- */
    dialogContent: {
      py: 3,
      px: 4,
      borderTop: `1px solid var(--theme-ui-colors-lightBorder)`,
      borderBottom: `1px solid var(--theme-ui-colors-lightBorder)`,
      flex: '1 1 auto',
      overflowY: 'auto',
    },
    dialogActions: {
      flex: '0 0 auto',
      padding: 2,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    header: {
      position: 'sticky',
      top: '0px',
      background: '#fff',
      zIndex: 1,
      alignItems: 'center',
      mb: 4,
    },
    snackbar: {
      visibility: 'hidden',
      minWidth: '250px',
      marginLeft: '-125px',
      backgroundColor: '#333',
      color: '#fff',
      textAlign: 'center',
      borderRadius: variables.radius,
      padding: 3,
      position: 'fixed',
      zIndex: 1,
      left: '50%',
      bottom: '30px',
      fontSize: 1,
    },
    main: {
      fontFamily: 'body',
      height: '100vh',
      width: '100vw',
      '*:focus': {
        outlineColor: 'primary',
      },
    },
    borderButton: {
      py: 2,
      px: 3,
      borderRadius: variables.radius,
      boxShadow: `inset 0 0 0 1px var(--theme-ui-colors-boxShadow)`,
      alignItems: 'center',
      mr: 2,
      ':hover': {
        bg: 'rgba(32,33,36,0.059)',
      },
    },
    borderButtonSelected: {
      variant: 'variants.borderButton',
      bg: 'rgba(32,33,36,0.1)',
      ':hover': {
        bg: 'rgba(32,33,36,0.1)',
      },
      pointerEvents: 'none',
    },
    link: {
      fontSize: 0,
      color: 'primary',
      textDecoration: 'none',
      ':hover': {
        textDecoration: 'underline',
      },
    },
    border: {
      border: '1px solid',
      borderColor: 'border',
      borderRadius: variables.radius,
      height: '100%',
      flex: 1,
    },
    icon: {
      color: 'textLighter',
      backgroundColor: 'transparent',
      height: '20px',
      width: '20px',
      borderRadius: variables.radius,
      display: 'inline-flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    iconTransparent: {
      variant: 'variants.icon',
      bg: 'transparent',
      color: 'iconBackground',
    },
    iconHover: {
      variant: 'variants.icon',
      '::before': {
        content: '""',
        transition: '.15s cubic-bezier(0.4, 0, 0.2, 1) transform, opacity',
        opacity: 0,
        transform: 'scale(0)',
        position: 'absolute',
        bottom: '-10px',
        left: '-10px',
        right: '-10px',
        top: '-10px',
        borderRadius: variables.radiusCircle,
      },
      ':hover': {
        '::before': {
          bg: 'rgba(30, 30, 30, 0.06)',
          border: 'none',
          boxShadow: 'none',
          opacity: 1,
          transform: 'scale(1)',
        },
      },
    },
    iconHoverTransparent: {
      variant: 'variants.iconTransparent',
      '::before': {
        content: '""',
        transition: '.15s cubic-bezier(0.4, 0, 0.2, 1) transform, opacity',
        opacity: 0,
        transform: 'scale(0)',
        position: 'absolute',
        bottom: '-10px',
        left: '-10px',
        right: '-10px',
        top: '-10px',
        borderRadius: variables.radiusCircle,
      },
      ':hover': {
        '::before': {
          bg: 'rgba(30, 30, 30, 0.06)',
          border: 'none',
          boxShadow: 'none',
          opacity: 1,
          transform: 'scale(1)',
        },
      },
    },
    avatar: {
      width: ['100%', '50%'],
      borderRadius: variables.radius,
    },
    fileUpload: {
      dropzone: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 3,
        margin: 3,
        borderWidth: '2px',
        borderRadius: '2px',
        borderColor: 'regularBorder',
        borderStyle: 'dashed',
        backgroundColor: 'buttonBackgroundSecondary',
        color: 'text',
        outline: 'none',
        transition: 'border .24s ease-in-out',

        ':focus': {
          borderColor: 'primary',
        },
        '&[data-is-drag-active="true"]': {
          borderColor: 'primary',
        },
      },
    },
  },
  layouts: {
    table: {
      background: 'var(--theme-ui-colors-background)',
      border: 'none',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      width: '100%',
      margin: 'auto',
    },
    td: {
      color: 'noTaskSelected',
      whiteSpace: 'nowrap',
      px: 2,
      py: 1,
      border: '1px solid',
      borderColor: 'selectedBackground',
      fontSize: 0,
      minWidth: '100px',
    },
  },
  properties: {
    inline: {
      container: {
        pb: 2,
        fontSize: 0,
        color: 'text',
      },
      label: {
        py: 1,
        pr: 1,
        display: 'inline-block',
      },
      normalValue: {
        p: 1,
        display: 'inline-block',
      },
      markedValue: {
        px: 2,
        py: 1,
        borderRadius: variables.radius,
        bg: 'selectedBackground',
        display: 'inline-block',
      },
    },
    table: {
      common: temporaryStylesHandle = {
        p: 0,
        border: '1px solid',
        whiteSpace: 'nowrap',
        fontSize: 0,
      },
      container: {
        text: {
          mx: 2,
          my: 1,
        },
        table: {
          m: '-1px',
        },
      },
      unchanged: {
        label: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          width: 7,
          color: 'label',
        },
        value: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          whiteSpace: 'normal',
          color: 'text',
        },
      },
      old: {
        label: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          borderRightColor: 'redBorder',
          bg: 'redBackground',
          width: 7,
          color: 'label',
        },
        value: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          bg: 'redBackground',
          whiteSpace: 'normal',
          color: 'text',
        },
      },
      new: {
        label: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          borderRightColor: 'greenBorder',
          bg: 'greenBackground',
          width: 7,
          color: 'noTaskSelected',
        },
        value: {
          ...temporaryStylesHandle,
          borderColor: 'regularBorder',
          bg: 'greenBackground',
          whiteSpace: 'normal',
          color: 'text',
        },
      },
    },
  },
  buttons: {
    primary: {
      fontSize: 1,
      color: 'background',
      bg: 'primary',
      borderRadius: variables.radius,
      width: 'auto',
      minWidth: space[6],
      p: 2,
      mr: 2,
      cursor: 'pointer',
      opacity: 1,
      transition: 'opacity 280ms cubic-bezier(0.4,0,0.2,1), background-color 280ms cubic-bezier(0.4,0,0.2,1)',
      ':hover:not(:disabled)': {
        opacity: 0.85,
      },
      ':disabled': {
        cursor: 'auto',
        color: 'background',
        bg: 'disabledPrimaryButton',
      },
      ':focus': {
        outlineColor: 'primary',
      },
    },
    secondary: {
      transition: 'opacity 280ms cubic-bezier(0.4,0,0.2,1), background-color 280ms cubic-bezier(0.4,0,0.2,1)',
      fontSize: 1,
      color: 'buttonText',
      bg: 'buttonBackgroundSecondary',
      borderRadius: variables.radius,
      width: 'auto',
      minWidth: space[6],
      p: 1,
      mr: 2,
      cursor: 'pointer',
      ':hover': {
        bg: '#cfdce5',
      },
      ':disabled': {
        cursor: 'auto',
        color: 'background',
        bg: 'secondary',
      },
      ':focus': {
        outlineColor: 'primary',
      },
    },
    transparent: {
      variant: 'buttons.primary',
      color: 'primary',
      bg: 'transparent',
      cursor: 'pointer',
      ':hover:not(:disabled)': {
        opacity: 1,
        bg: 'primaryLightest',
        color: 'primaryDarker',
      },
    },
    transparentRed: {
      variant: 'buttons.transparent',
      color: 'lighterRed2',
      ':hover:not(:disabled)': {
        opacity: 1,
        bg: 'redBackground',
        color: 'lighterRed',
      },
      ':focus': {
        outlineColor: 'lighterRed2',
      },
    },
  },
  forms: {
    label: {
      pb: 1,
      color: 'label',
      verticalAlign: 'middle',
      alignItems: 'center',
    },
    input: {
      p: 1,
      fontSize: 0,
      color: 'text',
      resize: 'none',
      border: '1px solid',
      borderColor: 'placeholder',
      borderRadius: variables.radius,
      width: '100%',
      caretColor: 'var(--theme-ui-colors-caretColor)',
      '&.MuiInputBase-root': {
        // Style material ui select
        color: 'text',
        fontSize: 0,
        p: 0,
        '> div': {
          px: 1,
          py: 2,
        },
        ':before': {
          content: 'none',
        },
      },
      ':focus': {
        outline: 'none',
        borderColor: 'primary',
      },
      '::placeholder': {
        color: 'placeholder',
      },
    },
  },
};
